<template>
    <div>
        <div v-for="(info, index) in infos" class="cart_box_par">
            <div class="cart_box">
                <div class="cb_item2">
                    <div class="cb_txt2">{{ convTypeToString(info.type) }}</div>
                    <div class="cb_txt3">{{ info.month }}{{ characters.for_month }}</div>
                </div>
                <div class="cb_item3">
                    <p v-if="info.price !==0">{{ '￥' + info.price.toLocaleString() }}</p>
                    <p v-if="info.price ===0">{{ characters.free }}</p>
                </div>
            </div>
        </div>
        <div class="confirm">
            <button type="submit" @click="openModal()">{{ characters.settle }}</button>
        </div>

        <div v-show="showModal">
            <transition name="modal">
                    <div class="modal-mask">
                        <div class="modal-wrapper" @click.self="closeModal()">
                            <div class="modal-container">
                                <div class="modal-header">
                                    <h3>{{ characters.choice_how_to_pay }}</h3>
                                </div>
                                <div class="modal-body">
                                    <div class="how-to-pay-kind screen-transition" v-for="pay_kind in pay_kinds" @click.once="pay(pay_kind, infos[0].item_id)">
                                        <div class="pay-way">{{ characters[pay_kind] }}</div>
                                        <div class="button-image">
                                            <img src="/image/icons/next.png">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            </transition>
        </div>
    </div>
</template>

<script>
    export default {
        name: "subscription-purchase",
        props: ['csrf_token', 'order_site', 'useable_payment', 'json_characters'],
        data: function () {
            return {
                infos: Array,
                showModal: false,
                pay_kinds: [],
                characters: Object,
            }
        },
        mounted() {
            axios.default
                .get('/subscription/info/get')
                .then(response => {
                    this.infos = response.data;
                });
            this.pay_kinds = JSON.parse(this.useable_payment);
            this.characters = JSON.parse(this.json_characters);
        },
        methods: {
            convTypeToString(type) {
                if(type == 0) return this.characters.general_member;
                if(type == 1) return this.characters.subscription_member;
            },
            openModal: function() {
                this.showModal=true;
            },
            closeModal: function() {
                this.showModal=false;
            },
            pay: function(selected_pay_kind, item_id) {
                const credit_pay_kind = ['credit'];
                const carrer_pay_kind = ['docomo', 'au', 'softbank'];
                const deffered_pay_kind = ['bank_transfer', 'mail_send'];
                if(credit_pay_kind.findIndex(pay_kind => pay_kind === selected_pay_kind) != -1) {
                    this.pay_credit(item_id);
                } else if(carrer_pay_kind.findIndex(pay_kind => pay_kind === selected_pay_kind) != -1) {
                    this.pay_career(selected_pay_kind, item_id);
                } else if(deffered_pay_kind.findIndex(pay_kind => pay_kind === selected_pay_kind) != -1){
                    this.pay_deffered(selected_pay_kind, item_id);
                }
            },
            pay_credit: function(item_id) {
                const pay_kind = 'credit';
                axios.default
                    .post('/subscription/purchase/pay', {pay_kind: pay_kind, item_id: item_id})
                    .then(response => {
                        let data = response.data;
                        if(data['err']) {
                            if(data['err']=='credit_unregist') {
                                location.href='/credit/regist?status=purchase';
                            } else {
                                alert(this.characters[data['err']]);
                                location.href='/subscription/purchase';
                            }
                        } else {
                            location.href='/subscription/purchase/end';
                        }
                    });
            },
            pay_career: function(pay_kind, item_id){
                axios.default
                    .post('/subscription/purchase/pay/career', {pay_kind: pay_kind, item_id: item_id})
                    .then(response => {
                        let data = response.data;
                        if(data['err']) {
                            alert(this.characters[data['err']]);
                            location.href='/subscription/purchase';
                        } else {
                            const url = data['url'];
                            location.href=url;
                        }
                    });
            },
            pay_deffered: function(pay_kind, item_id){
                axios.default
                    .post('/subscription/purchase/pay/deffered', {pay_kind: pay_kind, item_id: item_id})
                    .then(response => {
                        let data = response.data;
                        if(data['err']) {
                            alert(this.characters[data['err']]);
                            location.href='/subscription/purchase';
                        } else {
                            location.href='/subscription/purchase/end';
                        }
                    });
            },
            jumpSubscriptionPurchaseHistory: function() {
                location.href="/subscription/purchase/history";
            },
            jumpSubscriptionStatus: function() {
                location.href="/subscription/confirm";
            },
        }
    }
</script>

<style scoped>
</style>
